import {
  forwardRef,
  type HTMLAttributes,
  useContext,
  useEffect,
  useRef,
} from 'react';
import { DiceGameContext } from '@components/DiceGame/context.ts';
import cn from 'classnames';

import { MotionPicture } from '@/components/ui/Picture/Picture';

import { Tile } from '../Tile/Tile';
import { TilesBg } from '../TilesBg/TilesBg';

import flashPng from '/img/dice-game/flash-huge.png';
import flashWebp from '/img/dice-game/flash-huge.webp';

interface EnergyTileProps extends HTMLAttributes<HTMLDivElement> {
  isActive?: boolean;
  value: number;
}

const EnergyTile = forwardRef<HTMLDivElement, EnergyTileProps>(
  ({ value, ...props }, ref) => {
    const { setEnergyFromRef, setFlyingAnimation } =
      useContext(DiceGameContext);
    const imageRef = useRef<HTMLImageElement | null>(null);

    useEffect(() => {
      if (imageRef.current && props.isActive) {
        setEnergyFromRef(imageRef);
      }
    }, [props.isActive]);

    useEffect(() => {
      if (props.isActive) {
        setFlyingAnimation('energy');
      }
    }, [props.isActive]);

    return (
      <Tile
        ref={ref}
        {...props}
        variant={props.isActive ? 'dark' : 'grey'}
        className={cn(props.className, 'flex items-center justify-center')}
      >
        <div className="w-full h-full relative z-[2]">
          <MotionPicture
            ref={imageRef}
            className="absolute w-[80%] h-[80%] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            img={flashPng}
            webp={flashWebp}
            alt="flash"
          />
          <span className="absolute px-1 py-[0.125rem] left-1/2 -translate-x-1/2 bottom-[10.71%] font-bold text-sm leading-none rounded-[0.375rem] backdrop-blur-sm bg-black/20">
            +2
          </span>
        </div>
        {props.isActive && <TilesBg variant="green-active" />}
      </Tile>
    );
  },
);

export { EnergyTile };
